import Section from '../components/Section';

export default function Visao() {
  return (
    <main>
      <Section title="Nossa Visão">
        Ser líder na produção de etanol sustentável, promovendo desenvolvimento econômico com respeito ao meio ambiente.
      </Section>
    </main>
  );
}
